import axios from 'axios'

import apiInstance from '@/lib/axios'
import {
  IAuthParams,
  IChallengePasswordParams,
  IChangePasswordParams,
  IConfirmForgotPasswordParams,
  IConfirmSignUpParams,
  IEmailParams,
  IGlobalSignOutParams,
  IRefreshTokenData,
  IRefreshTokenParams,
  IResendConfirmationCodeData,
  IRevokeTokenParams,
  ISignInData,
  ISignUpData,
} from '@/typings'
import { getAPIConfig } from '@/utils/apiConfig'
import { getAuthToken } from '@/utils/auth'

export const signUp = async (body: IAuthParams): Promise<ISignUpData> => {
  const { data } = await apiInstance.post<ISignUpData>('/sign-up', body)
  return data
}

export const signIn = async (body: IAuthParams): Promise<ISignInData> => {
  const { data } = await apiInstance.post<ISignInData>('/sign-in', body, {
    headers: {
      'x-email': body.Username,
    },
  })
  return data
}

export const confirmSignUp = async (body: IConfirmSignUpParams): Promise<void> => {
  await apiInstance.post('/confirm-sign-up', body)
}

export const resendConfirmCode = async (body: IEmailParams): Promise<IResendConfirmationCodeData> => {
  const { data } = await apiInstance.post<IResendConfirmationCodeData>('/resend-confirmation-code', body)
  return data
}

export const forgotPassword = async (body: IEmailParams): Promise<IResendConfirmationCodeData> => {
  const { data } = await apiInstance.post<IResendConfirmationCodeData>('/forgot-password', body, {
    headers: {
      'x-email': body.Username,
    },
  })
  return data
}

export const confirmForgotPassword = async (body: IConfirmForgotPasswordParams): Promise<void> => {
  await apiInstance.post('/confirm-forgot-password', body)
}

export const refreshToken = async (body: IRefreshTokenParams): Promise<IRefreshTokenData> => {
  const { data } = await apiInstance.post<IRefreshTokenData>('/refresh-token', body)
  return data
}

export const globalSignOut = async (body: IGlobalSignOutParams): Promise<void> => {
  await apiInstance.post('/global-sign-out', body)
}

export const revokeToken = async (body: IRevokeTokenParams): Promise<void> => {
  await apiInstance.post('/revoke-token', body)
}

export const changePassword = async (body: IChangePasswordParams): Promise<void> => {
  const apiConfig = await getAPIConfig()
  const host = apiConfig.group
  const url = `${host}/change-password`
  const token = await getAuthToken()
  const headers = { Authorization: token ? `${token}` : '' }
  await axios.post(url, body, { headers })
}

export const challengePassword = async (body: IChallengePasswordParams): Promise<ISignInData> => {
  const { data } = await apiInstance.post<ISignInData>('/respond-to-auth-challenge', body)
  return data
}
